export const COOKIE_DOMAIN = (() => {
  const vercelUrl = process.env.NEXT_PUBLIC_VERCEL_URL
  const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
  const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'

  if (isProduction || isPreview) {
    return 'onceupon.photo'
  } else if (vercelUrl?.endsWith('.vercel.app')) {
    return vercelUrl
  } else {
    return 'localhost'
  }
})()

export const COOKIE_DEFAULT_OPTIONS = {
  path: '/',
  domain: COOKIE_DOMAIN,
  maxAge: 60 * 60 * 24 * 365, // 1 year
}

export const consentMode = { necessary: 'OU_necessary', analytical: 'OU_analytical', marketing: 'OU_marketing' }
